export default "__VITE_ASSET__C_K7uVTh__"